import { createSelector } from 'reselect';
import { initialState } from '../reducers/quickText.reducer';
import { QUICK_TEXTS } from '../constants/quickText.constants';

const selectState = state => state[QUICK_TEXTS] || initialState;

export const selectQuickTexts = () => createSelector(selectState, state => state.get('data').toList().sortBy(a => -a.get('id')));
export const selectQuickTextsFetched = () => createSelector(selectState, state => state.get('fetched'));